import type { Olympiad, OlympiadStatus } from './types';

export const SCHOOL_TIME_ZONE = 'America/Sao_Paulo';
const dayFormatter = new Intl.DateTimeFormat('sv-SE', { timeZone: SCHOOL_TIME_ZONE });
export const schoolDate = (now = new Date()) => dayFormatter.format(now);
export const addDays = (day: string, amount: number) => {
  const date = new Date(`${day}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + amount);
  return date.toISOString().slice(0, 10);
};
export function olympiadStatus(olympiad: Olympiad, now = new Date()): OlympiadStatus {
  const day = schoolDate(now);
  if (!olympiad.published || olympiad.enrollmentEnabled === false || olympiad.allowed === false
    || !olympiad.enrollmentStart || !olympiad.enrollmentEnd || day > olympiad.enrollmentEnd) return 'closed';
  return day < olympiad.enrollmentStart ? 'upcoming' : 'open';
}
export function millisecondsToNextSchoolDay(now = new Date()) {
  // Find the actual local-day boundary through Intl, including timezone offset changes.
  const day = schoolDate(now);
  let low = now.getTime(), high = low + 26 * 60 * 60 * 1000;
  while (high - low > 1) {
    const middle = Math.floor((low + high) / 2);
    if (schoolDate(new Date(middle)) === day) low = middle; else high = middle;
  }
  return Math.max(1, high - now.getTime());
}
export function calendarDays(cursor: string, week = false) {
  const first = week ? cursor : `${cursor.slice(0, 7)}-01`;
  const start = addDays(first, -new Date(`${first}T12:00:00Z`).getUTCDay());
  return Array.from({ length: week ? 7 : 42 }, (_, index) => {
    const iso = addDays(start, index);
    return { iso, date: Number(iso.slice(8)), outside: iso.slice(0, 7) !== cursor.slice(0, 7) };
  });
}
export function moveCalendar(cursor: string, amount: number, week: boolean) {
  if (week) return addDays(cursor, 7 * amount);
  const date = new Date(`${cursor.slice(0, 7)}-01T12:00:00Z`);
  date.setUTCMonth(date.getUTCMonth() + amount);
  return date.toISOString().slice(0, 10);
}
